var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoArredondarMais01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1208",
    d: "M2.9,21.6h4.2L3.7,33.1H0.6L2.9,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1209",
    d: "M22.3,16.1h-9.5v-3.4h9.5V2.9h3.5v9.8h9.6v3.4h-9.6V26h-3.5L22.3,16.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoArredondarMais01);
export default __webpack_public_path__ + "static/media/ico-funcao-arredondar-mais-01.4619b7574b1dee2cd63b663bcec6cf13.svg";
export { ForwardRef as ReactComponent };